import TableReportHelper from "report/helper";
import Trator from "./trator.jpeg";

export default async function ACIndicadorReportSummary( // pdf da visita ou pdf do laudo
    indicador,
    visita,
    tipoName,
    params,
    chartCallBack = null,
    unit = "%",
    fieldMediaConformidade = "conformidade",
    metaShow,
    showMeta = true,
    additionalColumn,
    secondChartCallBack = null
) {
    const h = new TableReportHelper(visita.data);

    const IndicadorClass = indicador.constructor;

    let averageConformidade = indicador.getAverage(visita, fieldMediaConformidade, tipoName);

    let averageConformidadeColeta1 = indicador.getAverage(visita, "conformeColeta1", tipoName);
    let averageConformidadeColeta2 = indicador.getAverage(visita, "conformeColeta2", tipoName);
    let averageConformidadeColeta3 = indicador.getAverage(visita, "conformeColeta3", tipoName);
    let averageConformidadeColeta4 = indicador.getAverage(visita, "conformeColeta4", tipoName);

    const statusColeta1 = IndicadorClass.getConformidadeStatus(
        averageConformidadeColeta1,
        params.meta,
        null,
        visita.cliente,
        indicador.type,
        tipoName
    );
    const statusColeta2 = IndicadorClass.getConformidadeStatus(
        averageConformidadeColeta2,
        params.meta,
        null,
        visita.cliente,
        indicador.type,
        tipoName
    );
    const statusColeta3 = IndicadorClass.getConformidadeStatus(
        averageConformidadeColeta3,
        params.meta,
        null,
        visita.cliente,
        indicador.type,
        tipoName
    );
    const statusColeta4 = IndicadorClass.getConformidadeStatus(
        averageConformidadeColeta4,
        params.meta,
        null,
        visita.cliente,
        indicador.type,
        tipoName
    );

    if (averageConformidade) {
        averageConformidade = averageConformidade.toFixed(3);
    }
    if (averageConformidade !== undefined) {
        async function convertImageToBase64(url) {
            const response = await fetch(url);
            const blob = await response.blob();

            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        }

        const tratorToBase64 = await convertImageToBase64(Trator);

        const content = [];

        const arrowColeta1 = [];
        const arrowColeta2 = [];
        const arrowColeta3 = [];
        const arrowColeta4 = [];

        let widths = ["*", "*", "*", "*"]
        
        let colsToShow = [
            h.panel([
                h.row([
                    h.panel(
                        [
                            h.row([h.text("Coleta 1", { alignment: "center" })]),
                            h.row([
                                h.text(`${parseFloat(averageConformidadeColeta1).toFixed(3)}%`, {
                                    alignment: "center",
                                }),
                            ]),
                        ],
                        { fillColor: IndicadorClass.getColorStatus(statusColeta1) }
                    ),
                ]),
                h.row([
                    h.panel([h.row([arrowColeta1]), h.row([h.empty()])], { alignment: "center" }),
                ]),
            ]),
            h.panel([
                h.row([
                    h.panel(
                        [
                            h.row([h.text("Coleta 2", { alignment: "center" })]),
                            h.row([
                                h.text(`${parseFloat(averageConformidadeColeta2).toFixed(3)}%`, {
                                    alignment: "center",
                                }),
                            ]),
                        ],
                        { fillColor: IndicadorClass.getColorStatus(statusColeta2) }
                    ),
                ]),
                h.row([
                    h.panel([h.row([arrowColeta2]), h.row([h.empty()])], { alignment: "center" }),
                ]),
            ]),
            h.panel([
                h.row([
                    h.panel(
                        [
                            h.row([h.text("Coleta 3", { alignment: "center" })]),
                            h.row([
                                h.text(`${parseFloat(averageConformidadeColeta3).toFixed(3)}%`, {
                                    alignment: "center",
                                }),
                            ]),
                        ],
                        { fillColor: IndicadorClass.getColorStatus(statusColeta3) }
                    ),
                ]),
                h.row([
                    h.panel([h.row([arrowColeta3]), h.row([h.empty()])], { alignment: "center" }),
                ]),
            ]),
            h.panel([
                h.row([
                    h.panel(
                        [
                            h.row([h.text("Coleta 4", { alignment: "center" })]),
                            h.row([
                                h.text(`${parseFloat(averageConformidadeColeta4).toFixed(3)}%`, {
                                    alignment: "center",
                                }),
                            ]),
                        ],
                        { fillColor: IndicadorClass.getColorStatus(statusColeta4) }
                    ),
                ]),
                h.row([
                    h.panel([h.row([arrowColeta4]), h.row([h.empty()])], { alignment: "center" }),
                ]),
            ]),
        ]

        if (averageConformidadeColeta4 === 0) {
            colsToShow = [
                h.panel([
                    h.row([
                        h.panel(
                            [
                                h.row([h.text("Coleta 1", { alignment: "center" })]),
                                h.row([
                                    h.text(`${parseFloat(averageConformidadeColeta1).toFixed(3)}%`, {
                                        alignment: "center",
                                    }),
                                ]),
                            ],
                            { fillColor: IndicadorClass.getColorStatus(statusColeta1) }
                        ),
                    ]),
                    h.row([
                        h.panel([h.row([arrowColeta1]), h.row([h.empty()])], { alignment: "center" }),
                    ]),
                ]),
                h.panel([
                    h.row([
                        h.panel(
                            [
                                h.row([h.text("Coleta 2", { alignment: "center" })]),
                                h.row([
                                    h.text(`${parseFloat(averageConformidadeColeta2).toFixed(3)}%`, {
                                        alignment: "center",
                                    }),
                                ]),
                            ],
                            { fillColor: IndicadorClass.getColorStatus(statusColeta2) }
                        ),
                    ]),
                    h.row([
                        h.panel([h.row([arrowColeta2]), h.row([h.empty()])], { alignment: "center" }),
                    ]),
                ]),
                h.panel([
                    h.row([
                        h.panel(
                            [
                                h.row([h.text("Coleta 3", { alignment: "center" })]),
                                h.row([
                                    h.text(`${parseFloat(averageConformidadeColeta3).toFixed(3)}%`, {
                                        alignment: "center",
                                    }),
                                ]),
                            ],
                            { fillColor: IndicadorClass.getColorStatus(statusColeta3) }
                        ),
                    ]),
                    h.row([
                        h.panel([h.row([arrowColeta3]), h.row([h.empty()])], { alignment: "center" }),
                    ]),
                ]),
            ]
            widths = ["*", "*", "*"]
        }

        if (averageConformidadeColeta3 === 0 && averageConformidadeColeta4 === 0) {
            colsToShow = [
                h.panel([
                    h.row([
                        h.panel(
                            [
                                h.row([h.text("Coleta 1", { alignment: "center" })]),
                                h.row([
                                    h.text(`${parseFloat(averageConformidadeColeta1).toFixed(3)}%`, {
                                        alignment: "center",
                                    }),
                                ]),
                            ],
                            { fillColor: IndicadorClass.getColorStatus(statusColeta1) }
                        ),
                    ]),
                    h.row([
                        h.panel([h.row([arrowColeta1]), h.row([h.empty()])], { alignment: "center" }),
                    ]),
                ]),
                h.panel([
                    h.row([
                        h.panel(
                            [
                                h.row([h.text("Coleta 2", { alignment: "center" })]),
                                h.row([
                                    h.text(`${parseFloat(averageConformidadeColeta2).toFixed(3)}%`, {
                                        alignment: "center",
                                    }),
                                ]),
                            ],
                            { fillColor: IndicadorClass.getColorStatus(statusColeta2) }
                        ),
                    ]),
                    h.row([
                        h.panel([h.row([arrowColeta2]), h.row([h.empty()])], { alignment: "center" }),
                    ]),
                ])
            ]
            widths = ["*", "*"]
        }






        if (statusColeta1 === "Ótimo") {
            arrowColeta1.push(h.hyphen());
        } else if (averageConformidadeColeta1 < parseFloat(params.meta)) {
            arrowColeta1.push(h.arrowDown(statusColeta1));
        } else if (averageConformidadeColeta1 > parseFloat(params.meta)) {
            arrowColeta1.push(h.arrowUp(statusColeta1));
        }

        if (statusColeta2 === "Ótimo") {
            arrowColeta2.push(h.hyphen());
        } else if (averageConformidadeColeta2 < parseFloat(params.meta)) {
            arrowColeta2.push(h.arrowDown(statusColeta2));
        } else if (averageConformidadeColeta2 > parseFloat(params.meta)) {
            arrowColeta2.push(h.arrowUp(statusColeta2));
        }

        if (statusColeta3 === "Ótimo") {
            arrowColeta3.push(h.hyphen());
        } else if (averageConformidadeColeta3 < parseFloat(params.meta)) {
            arrowColeta3.push(h.arrowDown(statusColeta3));
        } else if (averageConformidadeColeta3 > parseFloat(params.meta)) {
            arrowColeta3.push(h.arrowUp(statusColeta3));
        }

        if (statusColeta4 === "Ótimo") {
            arrowColeta4.push(h.hyphen());
        } else if (averageConformidadeColeta4 < parseFloat(params.meta)) {
            arrowColeta4.push(h.arrowDown(statusColeta4));
        } else if (averageConformidadeColeta4 > parseFloat(params.meta)) {
            arrowColeta4.push(h.arrowUp(statusColeta4));
        }

        content.push(
            h.panel(
                [
                    h.row([
                        h.panel(
                            [
                                {
                                    image: tratorToBase64,
                                    width: 150,
                                },
                            ],
                            { widths: ["*"], alignment: "center" }
                        ),
                    ]),
                    h.row([
                        h.panel(
                            [
                                colsToShow
                            ],
                            { widths: widths }
                        ),
                    ]),
                ],
                { widths: ["*"], colSpan: 2 }
            )
        );
        return content;
    } else {
        return null;
    }
}
